"use client";

import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { m, AnimatePresence } from "framer-motion";

type Faq = { id: string; question: string; answer: string };

export function FAQAccordion({ faqs }: { faqs: Faq[] }) {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <div className="mt-12 space-y-2">
      {faqs.map((faq) => {
        const open = openId === faq.id;
        return (
          <div
            key={faq.id}
            className="overflow-hidden rounded-xl border"
            style={{
              borderColor: "var(--border)",
              backgroundColor: "var(--card-bg)",
            }}
          >
            <h3 className="m-0">
            <button
              type="button"
              id={`faq-q-${faq.id}`}
              onClick={() => setOpenId(open ? null : faq.id)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-brand-500/5"
              aria-expanded={open}
              aria-controls={`faq-a-${faq.id}`}
            >
              <span
                className="text-base font-semibold"
                style={{ color: "var(--text)" }}
              >
                {faq.question}
              </span>
              <span
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
                style={{
                  backgroundColor: "var(--fi-brand-bg)",
                  color: "var(--fi-brand-fg)",
                }}
              >
                {open ? (
                  <Minus className="h-3.5 w-3.5" />
                ) : (
                  <Plus className="h-3.5 w-3.5" />
                )}
              </span>
            </button>
            </h3>
            <AnimatePresence initial={false}>
              {open && (
                <m.div
                  key="answer"
                  id={`faq-a-${faq.id}`}
                  role="region"
                  aria-labelledby={`faq-q-${faq.id}`}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.25, ease: "easeOut" }}
                  className="overflow-hidden"
                >
                  <p
                    className="px-5 pb-5 text-base leading-relaxed"
                    style={{ color: "var(--text-secondary)" }}
                  >
                    {faq.answer}
                  </p>
                </m.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
